import {
  FASTAG_PRICING_REQUEST,
  FASTAG_PRICING_SUCCESS,
  FASTAG_PRICING_FAILURE,
  FETCH_USER_DETAILS_BY_ID,
  TOA_TAG_ORDERS,
  GET_USER_ANALYTICS,
} from "./type";

const initialState = {
  fastagPricingResponse: false,
  data: null,
  error: null,
  transferTagResponse: {},
  fetchUserDetailsByIdResponse: {},
  toaTagOrdersResponse: {},
  userAnalytics: null,
};

const fastagPricingReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FASTAG_PRICING_REQUEST:
      return { ...state, fastagPricingResponse: payload, error: null };

    case FASTAG_PRICING_SUCCESS:
      return { ...state, fastagPricingResponse: payload, error: null };

    case FASTAG_PRICING_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_USER_DETAILS_BY_ID:
      return { ...state, fetchUserDetailsByIdResponse: payload, error: null };

    case TOA_TAG_ORDERS:
      return { ...state, toaTagOrders: payload, error: null };

    case GET_USER_ANALYTICS:
      return { ...state, userAnalytics: payload, error: null };

    default:
      return state;
  }
};

export default fastagPricingReducer;
